let __ = function (str, params = {}) {
    if (typeof str !== "string") {
        throw new TypeError("First argument must be a string.");
    }

    if (typeof params !== "object" || params === null) {
        throw new TypeError("Second argument must be an object.");
    }

    return str.replace(/%([a-zA-Z_][a-zA-Z0-9_]*)%/g, (match, key) => {
        return key in params ? params[key] : match;
    });
};

export default __;
